import React from "react";
import { SearchInputComponent } from "../../../common/components";
import { ServiceListSearchAndFiltersProps } from "./preneed-booking-requests-helper";
import { Stack, Badge, Box, Button } from "@mui/material";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import Filter from "./preneed-filter";
import "./preneed-booking-requests-search-filters.scss";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

type Props = ServiceListSearchAndFiltersProps & {
  /**
   *  NEW (optional):
   * - true  => show search + hint + filter + icons (default)
   * - false => show ONLY list/calendar icons
   */
  showListControls?: boolean;
};
const PreneedServiceListSearchAndFilters: React.FC<
  Props
> = ({
  onSearch,
  onFilterChange,
  onResetFilters,
  filterValues,
  placeholder = "Search by Customer Name, Order ID",
  appliedFiltersCount = 0,
  isFilterOpen = false,
  setIsFilterOpen,
  searchRef,
  isReset = false,
  localSearchText,
  setViewMode,
  viewMode,
  showListControls = true, //  default
}) => {
    return (
      <>
        <div className="preneed-search-and-filters-wrapper preneed-service-list-search-and-filters-wrapper preneed-booking-requests-search-and-filters-wrapper">
          {/*  Search only in list controls */}
          {showListControls && (
            <div className="preneed-search-input-wrapper">
              <SearchInputComponent
                placeholder={placeholder}
                onSearch={onSearch}
                ref={searchRef}
                localSearchText={localSearchText}
              />
            </div>
          )}
          <div
            className={`preneed-view-toggle-wrapper ${
              !showListControls
                ? "preneed-view-toggle-wrapper--icons-only"
                : ""
            }`}
          >
            {/*  Hint only in list controls */}
            {showListControls && (
              <div className="preneed-calendar-hint-box">
                <CalendarMonthOutlinedIcon className="preneed-calendar-hint-icon" />

                <span>
                  To see orders for specific dates switch to calendar view
                </span>
              </div>
            )}
            <Box className="preneed-view-toggle">
              <Button
                onClick={() => setViewMode("list")}
                variant="text"
                className={`preneed-toggle-btn ${viewMode === "list" ? "active" : ""}`}
              >
                <ViewListRoundedIcon />
              </Button>

              <Button
                onClick={() => setViewMode("calendar")}
                variant="text"
                className={`preneed-toggle-btn ${viewMode === "calendar" ? "active" : ""}`}
              >
                <CalendarMonthOutlinedIcon />
              </Button>
            </Box>
          </div>
          {/*  Filter only in list controls */}
          {showListControls && (
            <div className="preneed-service-list-filter-icon-and-button-wrapper">
              <div
                className="preneed-service-list-icon-filter preneed-filter-icon-wrapper"
                onClick={() => setIsFilterOpen?.(true)}
                tabIndex={0}
              >
                <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
                  <Badge
                    color="secondary"
                    badgeContent={appliedFiltersCount}
                    invisible={appliedFiltersCount === 0}
                  >
                    <div className="preneed-icon-image-and-text">
                      <img src={FilterIcon} alt="Filter Icon" />
                      Filter
                    </div>
                  </Badge>
                </Stack>
              </div>
            </div>
          )}
        </div>
        {/*  Filter modal only in list controls */}
        {showListControls && (
          <Filter
            open={isFilterOpen}
            onClose={() => setIsFilterOpen?.(false)}
            initialValues={filterValues}
            onApply={(filters) => {
              onFilterChange(filters);
            }}
            onReset={() => { }}
          />
        )}
      </>
    );
  };

export default PreneedServiceListSearchAndFilters;
